import React, { Component } from "react";
import NewRestaurant from "../images/new_restaurant.svg";
import Logout from "../images/logout.svg";
import Profilee from "../images/profile.svg";
import RestaurantItem from "../components/RestaurantItem";
import Placeholder from "../images/placeholder.png";
import { Modal } from "react-bootstrap";
import { WhisperSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";
import CustomButton from "../components/CustomButton";
import Profile from "./Profile";
import Tick from "../images/tick.svg";
import Cancel from "../images/cancel.svg";
import {
  BaseUrl,
  Authorization,
  BaseUrlAssets,
  BaseUrlPublic,
  isUser,
  LogoutFunction,
} from "../static.js";
import Tooltip from "@mui/material/Tooltip";

export default class Restaurants extends Component {
  constructor(props) {
    super(props);
    this.state = {
      businessList: [],
      loading: true,
      ModalShow: false,
      currentDeleteItemID: "",
      currentDeleteItemName: "",
      deleteLoading: false,
      modalContent: "",
    };

    this.getLanguages = this.getLanguages.bind(this);
  }

  componentDidMount() {
    let data = {};

    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "findUserBusiness", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        // console.log(result.result);
        if (result.status === 200) {
          this.setState(
            { loading: false, businessList: result.result },
            () => {}
          );
          this.getLanguages();
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // getLanguages() {
  //   let data = {
  //     countryVersion: "iran",
  //   };
  //   data = Object.assign(data, Authorization());

  //   fetch(BaseUrl + "getRemainCredit", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(data),
  //   })
  //     .then((res) => res.json())
  //     .then((result) => {
  //       console.log(result);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }

  getLanguages() {
    let data = {
      countryVersion: "iran",
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "getLanguageList", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  hideModal() {
    this.setState({ ModalShow: false, modalContent: "" });
  }

  editOptionsClick() {}

  onCreateNewItem() {
    this.props.onCreateNewRestaurant();
  }

  itemOnEdit(code) {
    this.props.onEditRestaurant(code);
  }

  itemOnDelete(id, name) {
    this.setState({
      ModalShow: true,
      currentDeleteItemID: id,
      currentDeleteItemName: name,
      modalContent: "delete",
    });
  }

  clickItem(code) {
    this.props.onClickRestaurant(code);
  }

  onLicenseClick(code) {
    this.props.onLicenseClick(code);
  }

  itemDeleteConfirm() {
    let data = {
      businessId: Number(this.state.currentDeleteItemID),
    };
    data = Object.assign(data, Authorization());

    this.setState({ deleteLoading: true });

    fetch(BaseUrl + "deleteBusiness", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        this.setState({ deleteLoading: false });
        if (result.status === 200) {
          this.setState({ businessList: result.result });
          this.hideModal();
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error("حذف مورد با مشکل مواجه شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        this.setState({ deleteLoading: false });
        console.log(err);
      });
  }

  onLogout() {
    LogoutFunction();
  }

  // startRecording(){
  //     this.setState({
  //         record: true
  //     });
  // }

  // stopRecording(){
  //     this.setState({
  //         record: false
  //     });
  // }

  // onData(recordedBlob) {
  //     console.log('chunk of real-time data is: ', recordedBlob);
  // }

  // onStop(recordedBlob) {
  //     console.log('recordedBlob is: ', recordedBlob);
  // }

  onProfile() {
    this.setState({ ModalShow: true, modalContent: "profile" });
  }

  render() {
    // if (this.state.serverResponse){
    return (
      <div className="Login">
        <div className="header">
          <div />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "fit-content",
              alignItems: "center",
            }}
          >
            <Tooltip title="اطلاعات کاربری">
              <div
                onClick={this.onProfile.bind(this)}
                className="linkStyle backButton"
                // data-tip="اطلاعات کاربری"
                // data-place="right"
              >
                <img src={Profilee} alt="" className="backButtonIcon" />
              </div>
            </Tooltip>
            <div
              style={{
                height: "20px",
                minWidth: "1px",
                backgroundColor: "var(--brown1)",
                margin: "0px 5px",
              }}
            />
            <Tooltip title="خروج">
              <div
                onClick={this.onLogout.bind(this)}
                className="linkStyle backButton"
                // data-tip="خروج"
                // data-place="bottom"
              >
                <img src={Logout} alt="" className="backButtonIcon" />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="LoginContent">
          <div className="RestaurantsListTitle">خوش آمدید</div>
          <div className="RestaurantsListSubTitle">
            لطفاً رستوران مورد نظر خود را انتخاب یا ایجاد کنید
          </div>
          <div className="restaurantsListContainer">
            <div
              className="newRestaurantItem"
              onClick={this.onCreateNewItem.bind(this)}
            >
              <img
                src={NewRestaurant}
                alt=""
                style={{ objectFit: "contain", height: "100%" }}
              />
              <div
                style={{
                  flex: "1",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                ایجاد رستوران جدید
              </div>
            </div>
            {!this.state.loading &&
              this.state.businessList.map((item, i) => {
                return (
                  <RestaurantItem
                    key={i}
                    img={
                      item.logo !== "" ? BaseUrlAssets + item.logo : Placeholder
                    }
                    id={item.id}
                    code={item.code}
                    info={item.info}
                    defaultLanguage={item.defaultLanguage}
                    title={item.name}
                    des={item.descr}
                    subscriptionType={item.subscriptionType}
                    expireTime={item.expireTime}
                    orderNum={13}
                    onEdit={this.itemOnEdit.bind(this)}
                    onDelete={this.itemOnDelete.bind(this)}
                    onClick={this.clickItem.bind(this)}
                    onLicenseClick={this.onLicenseClick.bind(this)}
                  />
                );
              })}

            {this.state.loading && (
              <div style={{ marginTop: "20px" }}>
                <WhisperSpinner
                  size={50}
                  color="var(--brown1)"
                  frontColor="var(--brown1)"
                  backColor="var(--brown1)"
                  loading={true}
                />
              </div>
            )}
          </div>
        </div>

        <Modal
          show={this.state.ModalShow}
          animation={false}
          onHide={this.hideModal.bind(this)}
          centered
        >
          {this.state.modalContent === "delete" && (
            <div className="dialogBox">
              اطمینان از حذف "{this.state.currentDeleteItemName}"؟
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="خیر"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    img={Cancel}
                    onClick={this.hideModal.bind(this)}
                  />
                </div>
                <div style={{ minWidth: "5px" }} />
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="بله"
                    loading={this.state.deleteLoading}
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    img={Tick}
                    onClick={this.itemDeleteConfirm.bind(this)}
                  />
                </div>
              </div>
            </div>
          )}

          {this.state.modalContent === "profile" && (
            <Profile hideModal={this.hideModal.bind(this)} />
          )}
        </Modal>
        {/* <ReactTooltip effect="solid" /> */}
      </div>
    );
    // }else{
    //     return(<Loading/>);
    // }
  }
}
